<template>
  <div id="checkout-layout">
    <div id="top-nav-checkout">
      <div class="container">
        <img
          :src="logoSrcUrl"
          alt="Karier.mu"
          id="logo-kariermu"
          @click="moveHomepage"
          :style="logoStyle"
        />
      </div>
    </div>
    <div class="main-wrapper-checkout">
      <slot />
    </div>
    <footer-copyright show-image class="hide-on-mobile"></footer-copyright>
  </div>
</template>

<script>

import ImageDefault from '@/assets/images/defaultImage/index'
import FooterCopyright from '@/components/FooterCopyright'
import platinumMixin from '@/mixins/platinumMixin'

export default {
  components: {
    FooterCopyright
  },
  data: () => ({
    logoSekolahmu: ImageDefault.logo_sekolahmu,
    iconSekolahmu: ImageDefault.icon_sekolahmu
  }),
  mixins: [platinumMixin],
  methods: {
    moveHomepage () {
      if (this.$route.path === '/checkout') {
        window.location.href = this.logoUrl
      }
    }
  },
  computed: {
    cdnEnv () {
      return process.env.VUE_APP_CDN_ENV
    },
    fullYear () {
      var date = new Date()
      var year = date.getFullYear()
      return year
    },
    logoStyle () {
      return {
        cursor: this.$route.path === '/checkout' ? 'pointer' : 'default'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#checkout-layout {
  font-family: "Open Sans", sans-serif;
}

#top-nav-checkout{
  display: flex;
  padding: 25px 0px;
  border-bottom: 1px solid #E0E0E0;
}

#logo-kariermu{
  width: auto;
  max-height: 30px;
}

.main-wrapper-checkout{
  min-height: calc(100vh - 91px - 106px - 170px);
  background-color: var(--color-neutral-400);
}

/* copy right */

#icon-sekolahmu-layout{
  width: 74px;
  height: 58px;
}

#footer-copyright-layout {
  min-height: 30px;
  background: #E0E0E0;
}

#copyright-layout {
  color: rgba(0, 0, 0, 0.3);
  padding-top: 41px;
  padding-bottom: 41px;
  display: flex;
  align-items: center;
  position: relative;
}

.image-layout-wrapper{
  display: flex;
  position: absolute;
}

.text-footer-layout-wrapper{
  text-align: center;
  width: 100%;
}

.hide-on-mobile {
  display: none;
}

@media screen and (min-width: 768px) {
  .hide-on-mobile {
    display: block;
  }

  .main-wrapper-checkout{
    padding-bottom: 170px;
  }
}

@media (max-width: 770px) {
  #footer-copyright-layout {
    font-size: 14px;
  }
}

@media screen and (max-width: 425px){
  #copyright-layout{
    flex-direction: column;
  }

  .image-layout-wrapper{
    position: relative;
  }

  .text-footer-layout-wrapper{
    margin-top: 20px;
  }
}

</style>
